
import { z } from "zod";

export const restaurantFormSchema = z.object({
  name: z.string().min(1, "Restaurant name is required"),
  address: z.string().min(1, "Address is required"),
  neighborhood_id: z.number().optional(),
  contact_email: z.string().email("Invalid email address").optional().or(z.literal("")),
  website: z.string()
    .min(1, "Website URL is required")
    .transform(val => {
      if (!/^https?:\/\//i.test(val)) {
        return `https://${val}`;
      }
      return val;
    })
    .refine(val => /^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(val), {
      message: "Invalid website URL",
    }),
  phone: z.string().optional().or(z.literal("")),
  description: z.string().optional().or(z.literal("")),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
});

export type RestaurantFormData = z.infer<typeof restaurantFormSchema>;
